import React from 'react';

import { Card } from '../../../../components/common/Card/Card';
import { Typography } from '../../../../components/common/Typography/Typography';
import { useDocumentHead } from '../../../../hooks/useDocumentHead/useDocumentHead';
import { useTranslation } from '../../../../hooks/useTranslation/useTranslation';
import styles from './PrivacyScreen.module.css';
import { PrivacyScreenProps } from './PrivacyScreen.types';

export const PrivacyScreen: React.FC<PrivacyScreenProps> = () => {
  const { t } = useTranslation();

  useDocumentHead({
    title: `${t.privacy.title} - ${t.brand}`,
    description: t.seo.privacyDescription,
  });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Typography variant="h1">{t.privacy.title}</Typography>
        <Typography variant="body2" className={styles.lastUpdated}>
          {t.privacy.lastUpdated}
        </Typography>
      </div>

      <Card className={styles.card}>
        <section className={styles.section}>
          <Typography variant="h3">{t.privacy.zeroDataTitle}</Typography>
          <Typography variant="body1" className={styles.text}>
            {t.privacy.zeroDataDesc}
          </Typography>
        </section>

        <section className={styles.section}>
          <Typography variant="h3">{t.privacy.localStorageTitle}</Typography>
          <Typography variant="body1" className={styles.text}>
            {t.privacy.localStorageDesc}
          </Typography>
        </section>

        <section className={styles.section}>
          <Typography variant="h3">{t.privacy.disclaimerTitle}</Typography>
          <div className={styles.disclaimerBox}>
            <Typography variant="body2">{t.privacy.disclaimerBox}</Typography>
          </div>
          <ul className={styles.list}>
            <li>
              <Typography variant="body2">{t.privacy.disclaimerItem1}</Typography>
            </li>
            <li>
              <Typography variant="body2">{t.privacy.disclaimerItem2}</Typography>
            </li>
          </ul>
        </section>

        <section className={styles.section}>
          <Typography variant="h3">{t.privacy.aiContentTitle}</Typography>
          <Typography variant="body1" className={styles.text}>
            {t.privacy.aiContentDesc}
          </Typography>
        </section>
      </Card>
    </div>
  );
};
